<div class="parent-container" [class.wcag]="wcag.isWCAG">
  <div class="container padding-top" [class.wcag]="wcag.isWCAG" [class.supportsWCAG]="config.supportsWcag"
    [ngStyle]="{ 'font-size': wcag.fontSize+'px'}">
    <app-reservation-wcag [wcag]="wcag" *ngIf="config.supportsWcag"></app-reservation-wcag>
    <div class="card mt-5" [class.wcag]="wcag.isWCAG">
      <div class="card-header">
        <app-reservation-header></app-reservation-header>
      </div>
      <div class="card-body">
        <app-reservation-form></app-reservation-form>
      </div>
    </div>
  </div>
</div>